import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { LiveDemoWidget } from "@/components/site/LiveDemoWidget";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
};

export default function Layout() {
  return (
    <div className="grain relative bg-[#0a0a0a] text-neutral-100 min-h-screen">
      <ScrollToTop />
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
      <LiveDemoWidget />
    </div>
  );
}
